/**
 * @file report页图表
 * @author fengfaxia(fengfaxia@baidu.com))
 */
import moment from 'moment';
import _ from 'lodash';

export const simMetricLine = (data, title) => {
    let chartdata = data && data.Data || [];
    const lineColor = '#999';
    if (!chartdata.length) {
        return {
            title: {
                text: '没有数据'
            },
            noData: true
        };
    }
    return {
        title: {
            show: true,
            text: title,
            x: 10,
            y: 14,
            textStyle: {
                color: '#555',
                fontSize: 14,
                fontWeight: 'bold'
            }
        },
        grid: {
            x: 50,
            y: 50,
            x2: 20,
            y2: 40
        },
        legend: {
            show: false
        },
        color: ['#6dbefd'],
        xAxis: [{
            type: 'category',
            boundaryGap: false,
            splitLine: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: lineColor,
                    width: 1
                }
            },
            data: _.map(chartdata, item => moment(parseInt(item.Timestamp * 1000, 10)).format('MM.DD'))
                .map(function (str) {
                    return str.replace(' ', '\n');
                })
        }],
        yAxis: [
            {
                type: 'value',
                splitLine: {
                    lineStyle: {
                        color: lineColor
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: lineColor,
                        width: 1
                    }
                },
                axisLabel: {
                    formatter: value => {
                        if (value >= 10000000000) {
                            return Math.round(value / 1000000000) + 'G';
                        }
                        else if (value >= 1000000) {
                            return Math.round(value / 1000000) + 'M';
                        }
                        else if (value >= 10000) {
                            return Math.round(value / 1000) + 'K';
                        }
                        return value;
                    }
                }
            }
        ],
        tooltip: {
            borderRadius: 0,
            padding: 0,
            backgroundColor: '#fff',
            extraCssText: 'box-shadow:0 0 3px 0 rgba(141,153,176,0.60);',
            trigger: 'axis',
            axisPointer: {
                type: 'line'
            },
            formatter: param => {
                let str = `<span class="tooltip-default" style="background: #108cee;">
                                ${param[0].axisValue}</span>`;
                _.each(param, item => {
                    if (item.value || item.value === 0) {
                        str = str
                        + `<br><span class="tooltip-default" style="color:${item.color}">${item.seriesName ? item.seriesName + ': ' : '' }`
                        + `${item.value}</span>`;
                    }
                });
                return str;
            }
        },
        series: [{
            smooth: true,
            symbolSize: 1,
            name: '',
            type: 'line',
            showAllSymbol: true,
            data: _.map(chartdata, item => item.Count),
            areaStyle: {
                normal: {
                    opacity: 1,
                    color: {
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        type: 'linear',
                        global: false,
                        colorStops: [
                            {
                                offset: 0,
                                color: 'rgba(185, 221, 251, 0.5)'
                            },
                            {
                                offset: 1,
                                color: 'rgba(255, 255, 255, 0.5)'
                            }
                        ]
                    }
                }
            }
        }]
    };
};

